(function() {
'use strict';

angular
    .module('TR')
    .controller('Auth', Auth);

function Auth($scope,
              $location,
              authService,
              resourceService,
              $window,
              modalService,
              $timeout,
              postBookingLookup,
              accountMenuService,
              $routeParams,
              loaderService,
              analytics) {
    const cm = this;
    const qs = $location.search();
    const authPages = ['signin', 'signup', 'forgot', 'bookingsignin', 'resetsent', 'verificationsent'];

    //models
    cm.bookingSigninModel = {
        bookingRef: null,
        bookingNumber: modalService.get('bookingId') || null,
        surname: getSurname(),
    };
    cm.forgot = { email: null };
    cm.registerModel = { email: null, password: null, emailSignUp: false };
    cm.resetModel = { password: null };
    cm.signinModel = { email: null, password: null };

    cm.tab = modalService.get('tab');
    cm.tabContent = modalService.get('tab');
    cm.cb = modalService.get('cb');

    cm.mybInfo = TRPCONFIG.Domain2.MybInfo;
    cm.mybRedirect = mybRedirect(cm.mybInfo);
    let isMobile = TRPCONFIG.IsMobileView;

    cm.numbersOnly = numbersOnly();

    let email = modalService.get('email');
    if (email) {
        cm.signinModel.email = email;
        cm.registerModel.email = email;
    }

    if ($routeParams.returnUrl) {
        authService.bufferRoute($routeParams.returnUrl, true);
    }

    $scope.$on('$destroy', function() {
        modalService.destroy('tab');
    });

    modalService.onSet('tab', function(tab) {
        switchTab(tab, false, false);
    });

    modalService.onSet('cb', function(cb) {
        cm.cb = cb;
    });

    modalService.onSet('email', function(email) {
        cm.signinModel.email = email;
        cm.registerModel.email = email;
    });

    loaderService.loadJS($window.document, 'script', 'facebook-jssdk', `//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9&appId=${$window.TRPCONFIG.Domain.FacebookAppId}`);
    loaderService.loadJS($window.document, 'script', 'google-jssdk', '//apis.google.com/js/client:platform.js');

    cm.cancelAuth = cancelAuth;
    cm.forgotPassword = forgotPassword;
    cm.signin = signin;
    cm.switchTab = switchTab;
    cm.login = login;
    cm.switchTabContent = switchTabContent;
    cm.register = register;
    cm.showHeaders = true;
    cm.byAgent = TRPCONFIG.Domain.BookingSignInByAgent;
    cm.verificationContinue = verificationContinue;
    cm.bookingSignIn = bookingSignIn;
    cm.toManage = toManage;

    cm.contact = authService.getUser();
    cm.resetPassword = resetPassword;
    cm.showForm = !TRPCONFIG.Domain.SocialSignin;
    cm.signInWithEmail = signInWithEmail;
    cm.verify = verify;
    cm.verifyAndChoose = verifyAndChoose;

    $timeout(function() { cm.deleteButton = resourceService.get('DELETEACCOUNT'); });

    function getSurname() {
        let ls = localStorage.getItem('bndDetails');
        let surname = null;
        if (ls) {
            ls = JSON.parse(ls);
            surname = ls.surname;
        }

        return surname;
    }

    function resetPassword(model) {
        authService.changePasswordWithToken({
            UserId: qs.userId,
            NewPassword: model.password,
            VerificationToken: qs.token
        }).then(function(res) {
            if (res.Result === 0) {
                $location.path('resetsuccessful');
            } else {
                $scope.$emit('flash:error', resourceService.get('RESETPASSWORDFAILURE'));
            }
        });
    }

    function signInWithEmail() {
        cm.showForm = true;
    }

    function verify() {
        authService.verify({
            UserId: qs.userId,
            VerificationToken: qs.token
        }).then(function(resp) {
            if (resp.Success) {
                $location.path('verified');
            } else {
                $scope.$emit('flash:error', resourceService.get('VERIFYFAILURE'));
            }
        });
    }

    function verifyAndChoose(password) {
        const changePasswordRequest = {
            UserId: qs.userId,
            NewPassword: password,
            VerificationToken: qs.token
        };

        authService.changePasswordWithToken(changePasswordRequest).then(function(res) {
            if (res.Result === 0) {
                $location.path('verified');
            } else {
                $scope.$emit('flash:error', resourceService.get('VERIFYFAILURE'));
            }
        });
    }


    function _cancelEvent(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    function login(provider, event) {
        cm.busy = true;
        _cancelEvent(event);

        if (cm.tab === 'signup' || location.href.indexOf('/signup') >= 0) {
            //tracking only the clicks when it is a signUp event, not tracking the signup success
            analytics.track('mixpanel', 'UserSignUp', {
                IdentityProvider: provider
            });
        }

        switch (provider) {
            case 'facebook':
                _facebookLogin();
                break;
            case 'google':
                _googleLogin();
                break;
        }
    }

    function _isAuthPage() {
        const url = $location.path().substring(1);
        for (const i in authPages) {
            if (url.indexOf(authPages[i]) >= 0) {
                return true;
            }
        }
        return false;
    }

    function switchTab(tab, event, hideHeaders) {
        if (_isAuthPage()) {
            $location.url(tab);
            return;
        }
        $scope.$emit('flash:hide');
        cm.showHeaders = !hideHeaders;
        cm.errorMB = false;
        cm.mybErrorMsg = '';
        _cancelEvent(event);
        cm.tab = tab;
        cm.switchTabContent(tab);
    }

    function switchTabContent(tab, event) {
        if (_isAuthPage()) {
            $location.url(tab);
            return;
        }
        $scope.$emit('flash:hide');
        _cancelEvent(event);
        cm.tabContent = tab;
    }

    $window.fbAsyncInit = function() {
        $window.FB.init({
            xfbml: true,
            version: 'v2.9',
            appId: $window.TRPCONFIG.Domain.FacebookAppId
        });
    };

    function _postSignin(resp) {
        switch (resp.Result) {
            case 0:
                if (cm.cb) {
                    cm.cb();
                }
                _closeModal();
                break;

            case 1:
                $scope.$broadcast('flash:error', resourceService.get('SIGNINFAILURE'));
                break;

            case 2:
                $scope.$broadcast('flash:error', resourceService.get('EMAILADDRESSNOTFOUND'));
                break;
        }
        cm.busy = false;

        if (!(cm.tab === 'signup' || location.href.indexOf('/signup') >= 0)) {
            //To track only signIn event, after the signIn success
            analytics.track('mixpanel', 'UserSignedIn', {
                IdentityProvider: (resp.User && resp.User.Identity) ? resp.User.Identity.Provider : 'none'
            });
        }
    }

    function _socialSignIn(provider, token) {
        return authService.socialSignin({
            Provider: provider,
            AccessToken: token,
            ContextTag: 'Source:Website-Social'
        }).then(_postSignin);
    }

    function _facebookLogin() {
        /* eslint-disable camelcase */
        $window.FB.login(function(response) {
                if (!response.authResponse) {
                    $scope.$broadcast('flash:error', resourceService.get('SIGNINFAILURE'));
                } else {
                    _socialSignIn('facebook', response.authResponse.accessToken);
                }
            },
        {
            scope: 'email',
            auth_type: 'rerequest'
        });
    }
    /* eslint-enable camelcase */

    function _googleLogin() {
        $window.gapi.auth.authorize({
            /* eslint-disable camelcase */
            client_id: $window.TRPCONFIG.Domain.GoogleAppId,
            response_type: 'token',
            /* eslint-enable camelcase */
            scope: 'openid profile email'
        },
        function(response) {
            if (response.error) {
                $scope.$broadcast('flash:error', resourceService.get('SIGNINFAILURE'));
                cm.busy = false;
            } else if (response.status.signed_in) {
                _socialSignIn('google', response.access_token);
            }
        });
    }


    function cancelAuth() {
        if (_isAuthPage()) {
            const route = authService.getNextRoute();
            if (qs.cb) {
                $location.url(decodeURIComponent(qs.cb));
            } else {
                $location.url(route.length > 0 ? route : 'hotel');
            }
            return;
        }
        _closeModal();
    }

    function _closeModal() {
        modalService.close();
    }

    function signin(model, event) {
        _cancelEvent(event);

        cm.busy = true;
        authService.signin({
            Email: model.email || '',
            Password: model.password || ''
        }).then(_postSignin);
    }

    function register(model, event) {
        _cancelEvent(event);
        cm.busy = true;

        let email = _.get(model, 'email', '').split('@');
        if (!model.email || (email.length > 1 && email[1].split('.').length <= 1)) {
            _signupError();
            return;
        }

        authService.register({
                Email: model.email,
                Password: model.password,
                ContextTag: 'Source:Website',
                EmailSignUp: model.emailSignUp,
                Source: 'TravelRepublic',
                SignUpReason: 'Website User Registration'
            })
            .then(function(resp) {
                if (resp.Result === 0) {
                    cm.switchTab('verificationsent', false, true);
                    analytics.track('mixpanel', 'UserSignUp', {
                        IdentityProvider: 'EmailSignUp'
                    });
                } else {
                    _signupError();
                }
                cm.busy = false;
            }, _signupError);
    }

    function _signupError() {
        $scope.$broadcast('flash:error', resourceService.get('ACCOUNTSIGNUPERROR'));
        cm.busy = false;
    }

    function forgotPassword(model) {
        cm.busy = true;
        authService.forgotPassword({
            Email: model.email
        }).then(function(res) {
            if (res.Success) {
                cm.switchTab('resetsent', false, true);
            } else {
                $scope.$emit('flash:error', resourceService.get('FORGOTPASSWORDFAILURE'));
            }
            cm.busy = false;
        });
    }


    function verificationContinue(event) {
        _cancelEvent(event);
        if (_isAuthPage()) {
            let route = authService.getNextRoute();
            if (route.length === 0) {
                route = qs.cb ? qs.cb : '';
            }

            $location.url(route);
        }

        authService.bufferRoute(null);
        _closeModal();
    }

    function bookingSignIn(model, event) {
        _cancelEvent(event);
        cm.busy = true;
        cm.errorMB = false;
        cm.mybErrorMsg = '';

        if (cm.byAgent) {
            bookingSignInByAgent(model.bookingNumber);
            return;
        }

        const ref = `${model.bookingRef}/${model.bookingNumber}`;
        authService
            .anonSignIn(ref, model.surname)
            .then(loginResult);
    }

    function bookingSignInByAgent(bookingNumber) {
        authService
            .bookingSignInByAgent(bookingNumber)
            .then(loginResult);
    }

    function loginResult(res) {
        cm.busy = false;
        if (res) {
            if (!authService.redirectToBufferedRoute()) {
                postBookingLookup.redirect();
            }
            _closeModal();
            return;
        }
        $scope.$broadcast('flash:error', resourceService.get('LOOKUPFAIL'));

        let modalOverlay = document.querySelector('.modal-overlay');

        if (!isMobile) {
            setTimeout(function() {
                let errorText = document.querySelectorAll('.myb-error')[1];
                if (errorText && window.innerWidth >= 880) {
                    if (modalOverlay.style.display === 'block') {
                        errorText.style.display = 'none';
                    } else {
                        errorText.style.display = 'block';
                    }
                } else {
                    errorText.style.display = 'block';
                }
            }, 100);
        }

        if (!res) {
            cm.errorMB = true;
            cm.mybErrorMsg = resourceService.get('MYBERROR');
        }
    }

    function getUrlPrefix(url) {
        let prefix = url.split('emirates');
        return prefix[0];
    }

    function numbersOnly() {
        let bn = document.querySelectorAll('.bookingNumber')[0];
        if (bn) {
            bn.addEventListener('keypress', e => {
                const key = e.key;
                if (!key.match(/^\d+$/)) {
                    e.preventDefault();
                }
            });
        }
    }

    function mybRedirect(info) {
        setTimeout(() => {
            let bnd = document.querySelector('.bookingNumber');
            if (bnd && bnd.value === '0') {
                bnd.value = '';
            }
        }, 100);

        let target = document;
        let formFound = false;
        let modalHeaderFound = false;
        let observer = new MutationObserver(mutations => {
            mutations.forEach(() => {
                let isPopup = document.querySelector('.ekh-myb-panel form[name="formBookingSignIn"]');
                let form = document.querySelector('.signin-form');
                let authPopup = document.querySelector('.auth-popup');
                let mybPanel = document.querySelector('.ekh-myb-panel');
                let modalHeader = document.querySelectorAll('.modal-header')[0];
                if (modalHeader && !modalHeaderFound) {
                        modalHeaderFound = true;
                        authService.firstRedirect = true;
                        let overlay = modalHeader.closest('.modal-overlay');
                        if (!overlay.style.display) {
                            overlay.style.display = 'none';
                        }
                }

                if (isPopup === null && mybPanel && form && !formFound && !isMobile) {
                    formFound = true;
                    let searchPanel = document.querySelector('.ekh-search-panel');
                    let link = modalHeader.querySelector('a');

                    if (window.innerWidth >= 880) {
                        link.click();
                        searchPanel.classList.add('panel-hide');
                        mybPanel.classList.remove('panel-hide');
                        mybPanel.appendChild(form);
                    } else {
                        mybPanel.classList.add('panel-hide');
                        authPopup.appendChild(form);
                    }

                    observer.disconnect();
                }
            });
        });

        let config = {
            subtree: true,
            attributes: true,
            childList: false,
            characterData: false
        };

        observer.observe(target, config);

        if (info) {
            let lang = info.DomainBookedOn.Languages;
            let code = lang.filter(x => x.Code !== 'ar-AE' ? x.Code : null);
            let langCode = code[0].Code;
            langCode = langCode.toLowerCase();
            langCode = langCode.split('-');

            let country = info.DomainBookedOn.CountryCode;
            country = country.toLowerCase();
            let codes = `${country}_${langCode[0]}`;

            let bnd = info.BookingRef;
            bnd = bnd.split('/');
            let bndRef = bnd[1];
            let url = window.location.href;
            let prefix = getUrlPrefix(url);

            let domainName = info.DomainBookedOn.Name;
            let domainId = info.DomainBookedOn.Id;

            if (domainId === 107) {
                info.DomainBookedOn.Label = 'UK';
                domainName = 'emiratesholidays.com';
            } else if (domainName !== 'emiratesholidays.com' &&
                domainName !== 'emiratesvacations.com') {
                return `/${codes}/dashboard/booking-details/${bndRef}`;
            }

            let fullURL = `${prefix}${domainName}`;
            let finalURL = `${fullURL}/${codes}/dashboard/booking-details/${bndRef}`;

            return finalURL;
        }
    }

    function toManage() {
        authService.bufferRoute(null);
        accountMenuService.launchOption('bookingsignin');
    }
}
})();
